/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quicktools_Tab_ErrorsInputs */

const en_quicktools_tab_errors = /** @type {(inputs: Quicktools_Tab_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errors`)
};

const fr_quicktools_tab_errors = /** @type {(inputs: Quicktools_Tab_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreurs`)
};

const de_quicktools_tab_errors = /** @type {(inputs: Quicktools_Tab_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler`)
};

const it_quicktools_tab_errors = /** @type {(inputs: Quicktools_Tab_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errori`)
};

const ru_quicktools_tab_errors = /** @type {(inputs: Quicktools_Tab_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибки`)
};

const es_quicktools_tab_errors = /** @type {(inputs: Quicktools_Tab_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errores`)
};

const zh_cn2_quicktools_tab_errors = /** @type {(inputs: Quicktools_Tab_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`错误`)
};

const ja_quicktools_tab_errors = /** @type {(inputs: Quicktools_Tab_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エラー`)
};

const hi_quicktools_tab_errors = /** @type {(inputs: Quicktools_Tab_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`त्रुटियाँ`)
};

const pt_pt2_quicktools_tab_errors = /** @type {(inputs: Quicktools_Tab_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erros`)
};

/**
* | output |
* | --- |
* | "Errors" |
*
* @param {Quicktools_Tab_ErrorsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const quicktools_tab_errors = /** @type {((inputs?: Quicktools_Tab_ErrorsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quicktools_Tab_ErrorsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_quicktools_tab_errors(inputs)
	if (locale === "de") return de_quicktools_tab_errors(inputs)
	if (locale === "it") return it_quicktools_tab_errors(inputs)
	if (locale === "ru") return ru_quicktools_tab_errors(inputs)
	if (locale === "es") return es_quicktools_tab_errors(inputs)
	if (locale === "zh-CN") return zh_cn2_quicktools_tab_errors(inputs)
	if (locale === "ja") return ja_quicktools_tab_errors(inputs)
	if (locale === "hi") return hi_quicktools_tab_errors(inputs)
	if (locale === "pt-PT") return pt_pt2_quicktools_tab_errors(inputs)
	return en_quicktools_tab_errors(inputs)
});